import monkeyPatch from "./monkeyPatch.js";

/**
 * Erweitert alle Javascript-Map um einen Satz von Hilfsmethoden (Monkeypatching).
 * FUCK YOU ES6-Standards-Kommitee! Warum ist das nicht Teil des Standards !?!?!?!?!?!?!
 */
monkeyPatch(Map.prototype, {

    /**
     * ruf mapper(value,key) für jeden Eintrag der Map auf und baut eine Array mit den
     * Rückgabewerten auf
     */
    map(mapper) {
        const list = [];
        this.forEach((value, key) => {
            list.push(mapper(value, key));
        });
        return list;
    },

    reduce(mapper, startValue) {
        return Array.from(this).reduce((accu, current) => mapper(accu, current[1]), startValue);
    },

    /**
     * sucht nach erstem Element für das predicate True ergibt und gibt ein {key,value} zurück
     * @param predicate
     * @returns Object with key and value
     */
    find(predicate) {
        for (let [key,value] of this) {
            if (predicate(value, key)) {
                return {key, value};
            }
        }
    },

    /**
     * Gibt eine Liste von {key,value} - entries zurück, auf welche Predikate passt
     * @param predicate
     * @returns Object with key and value
     */
    filter(predicate) {
        const entries = [];
        for (let [key,value] of this) {
            if (predicate(value, key)) {
                entries.push({key, value});
            }
        }
        return entries;
    },

    /**
     *  reverse Lookup to find a key, to a given value;
     * @param value
     */
    getKey(value) {
        const r = this.find((v, k) => v === value);
        return r === undefined ? r : r.key;
    },

    /**
     * true wenn predicate für ein (value,key) - Paar true ist
     * @param predicate
     */
    some(predicate) {
        for (let [key,value] of this) {
            if (predicate(value, key)) {
                return true;
            }
        }
        return false;
    },


    /**
     * true wenn predicate für alle (value,key) - Paare true ist
     * @param predicate
     */
    every(predicate) {
        for (let [key,value] of this) {
            if (!predicate(value, key)) {
                return false;
            }
        }
        return true;
    },

    /**
     * ein effizientes .map(mapper).find(x=>x)
     */
    findMap(mapper) {
        for (let [key,value] of this) {
            const result = mapper(value, key);
            if (result!=null) {
                return result;
            }
        }
        return undefined;
    }

});

/**
 * Welcher Vollpfosten hatte diese glorreiche Idee: array.length aber map.size???????
 * Sowas ist einfach nur kognitiver Müll!
 * Das hier ist zwar nicht so performant, aber solche Fehler sind teilweise schwer zu finden,
 * daher lieber Bugfreiheit.
 * for the record:
 * https://stackoverflow.com/questions/35038750/why-do-javascript-sets-maps-use-size-instead-of-length
 * Idioten!
 */
if (!Object.getOwnPropertyDescriptor(Map.prototype, 'length')) {
    Object.defineProperty(Map.prototype, "length", {
        get() {
            return this.size;
        }
    });
}
